import React, { useState } from 'react'
import Axios from 'axios'
import { Form, Col, Row, Input, FormGroup, CardBody, Button } from 'reactstrap'

const INITIAL_STATE = {
  nombre:'',
  apellido:'',
  email:'',
  telefono:'',
  mensaje:''
}

function Formulario(){
  const [data, setData] = useState(INITIAL_STATE)
  const [isLoading, setIsLoading] = useState(false)
  const [notification, setNotification] = useState({ show: false, type: '', message: '' })

  const handleOnChange = event => {
    event.stopPropagation()
    setData({...data, [event.target.name]: event.target.value})
  }
  
  const handleInputFocus = (event) => {
    event.stopPropagation()
  }
  const handleOnSubmit = async (event) => {
    event.preventDefault();
		const { nombre, apellido, email, telefono, mensaje } = data 
		
    // Preparar datos para la nueva Cloud Function
    const formData = {
      nombre: `${nombre} ${apellido}`, // Combinar nombre y apellido
      email: email,
      telefono: telefono,
      asunto: 'Consulta desde Altos del Quelhue',
      mensaje: mensaje,
      destinatarios: ['altosdelquelhue@gmail.com'], // Destinatario específico del proyecto
      prefijo_asunto: '[Altos del Quelhue]', // Prefijo personalizado
      campos_adicionales: {
        tipo_consulta: 'Contacto Web',
        proyecto: 'Altos del Quelhue'
      }
    }

		setIsLoading(true)
		
		try {
		  const response = await Axios.post('https://sendformemail-6al5a3ncoq-uc.a.run.app', formData, {
		    headers: {
		      'Content-Type': 'application/json',
		    }
		  })
		  
		  console.log('✅ Mensaje enviado exitosamente:', response.data)
		  setIsLoading(false)
		  setData(INITIAL_STATE)
		  
		  // Mostrar mensaje de éxito al usuario
		  setNotification({ 
		    show: true, 
		    type: 'success', 
		    message: '¡Enviado! Te contactaremos pronto.' 
		  })
		  
		  // Ocultar notificación después de 5 segundos
		  setTimeout(() => {
		    setNotification({ show: false, type: '', message: '' })
		  }, 5000)
		  
		} catch (error) {
		  console.error('❌ Error al enviar mensaje:', error)
		  setIsLoading(false)
		  
		  // Mostrar mensaje de error al usuario
		  setNotification({ 
		    show: true, 
		    type: 'error', 
		    message: 'Hubo un error al enviar el mensaje. Inténtalo nuevamente.' 
		  })
		  
		  // Ocultar notificación después de 5 segundos
		  setTimeout(() => {
		    setNotification({ show: false, type: '', message: '' })
		  }, 5000)
		}
	};
  const { nombre, apellido, email, telefono, mensaje } = data
  const isDisabled = nombre === '' || apellido === '' || email === '' || telefono === '' || mensaje === ''
  return(
    <div style={{ position: 'relative' }}>
      {/* Notificación estilizada */}
      {notification.show && (
        <div 
          className={`alert ${notification.type === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show mb-3`}
          role="alert"
          style={{
            position: 'absolute',
            top: '-60px',
            right: '0',
            zIndex: 1050,
            minWidth: '300px',
            maxWidth: '100%',
            borderRadius: '10px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            fontWeight: '500'
          }}
        >
          <div className="d-flex align-items-center">
            <span className="me-2">
              {notification.type === 'success' ? '✅' : '❌'}
            </span>
            {notification.message}
          </div>
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setNotification({ show: false, type: '', message: '' })}
            aria-label="Close"
          ></button>
        </div>
      )}
      
      <Form onSubmit={handleOnSubmit} style={{ touchAction: 'manipulation' }}>
        <CardBody>
            <Row>
                <Col md="6">
                    <FormGroup className="label-floating">
                        <label className="control-label">
                            Nombre
                        </label>
                        <Input
                            name="nombre"
                            value={nombre}
                            onChange={handleOnChange}
                            onFocus={handleInputFocus}
                            placeholder=""
                            type="text"
                            autoComplete="off"
                            inputMode="text"
                            style={{ 
                              WebkitAppearance: 'none',
                              touchAction: 'manipulation',
                              userSelect: 'text'
                            }}
                        />
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup className="label-floating">
                        <label className="control-label">
                            Apellido
                        </label>
                        <Input
                            name="apellido"
                            value={apellido}
                            onChange={handleOnChange}
                            onFocus={handleInputFocus}
                            placeholder=""
                            type="text"
                            autoComplete="off"
                            inputMode="text"
                            style={{ 
                              WebkitAppearance: 'none',
                              touchAction: 'manipulation',
                              userSelect: 'text'
                            }}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup className="label-floating">
                        <label className="control-label">
                            Teléfono
                        </label>
                        <Input
                            name="telefono"
                            value={telefono}
                            onChange={handleOnChange}
                            onFocus={handleInputFocus}
                            placeholder=""
                            type="tel"
                            autoComplete="off"
                            inputMode="tel"
                            style={{ 
                              WebkitAppearance: 'none',
                              touchAction: 'manipulation',
                              userSelect: 'text'
                            }}
                        />
                    </FormGroup>
                </Col>
            </Row>
                <FormGroup className="label-floating">
                    <label className="control-label">
                        Email 
                    </label>
                    <Input
                            name="email"
                            value={email}
                            onChange={handleOnChange}
                            onFocus={handleInputFocus}
                            placeholder=""
                            type="email"
                            autoComplete="off"
                            inputMode="email"
                            style={{ 
                              WebkitAppearance: 'none',
                              touchAction: 'manipulation',
                              userSelect: 'text'
                            }}
                        />
                    </FormGroup>
                    <FormGroup className="label-floating">
                        <label className="control-label">
                            Mensaje
                        </label>
                        <Input
                            id="message"
                            name="mensaje"
                            value={mensaje}
                            onChange={handleOnChange}
                            placeholder=""
                            type="textarea"
                            rows="6"
                            style={{ 
                              WebkitAppearance: 'none',
                              touchAction: 'manipulation',
                              userSelect: 'text',
                              resize: 'vertical'
                            }}
                        />
                    </FormGroup>
                    <Row>
                        <Col md="6">
                            <Button type ="submit" color="primary" disabled={isDisabled}>
                                {isLoading && 
                                    <div className="uil-reload-css reload-small mr-1">
                                        <div />
                                    </div>
                                }
                                Enviar
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
      </Form>
    </div>
  )}
export default Formulario
    // <Form onSubmit={handleOnSubmit}>
    //   <FormGroup>
    //     <Label>Nombre</Label>
    //     <Input
    //       type="text"
    //       name="nombre"
    //       value={nombre}
    //       onChange={handleOnChange}
    //     />
    //   </FormGroup>
    //   <FormGroup>
    //     <Label>
    //       Email
    //     </Label>
    //     <Input
    //       type="email"
    //       name="email"
    //       value={email}
    //       onChange={handleOnChange}
    //     />
    //   </FormGroup>
    //   <FormGroup>
    //     <Label>
    //       Telefono
    //     </Label>
    //     <Input
    //       type="text"
    //       name="telefono"
    //       value={telefono}
    //       onChange={handleOnChange}
    //     />
    //   </FormGroup>
    //   <FormGroup>
    //     <Label>
    //       Mensaje
    //     </Label>
    //     <Input
    //       type="text"
    //       name="mensaje"
    //       value={mensaje}
    //       onChange={handleOnChange}
    //     />
    //   </FormGroup>
    //   {isLoading ? 
    //     <span>Enviando...</span> :
    //     <Button
    //       type="submit"
    //       disabled={isDisabled}
    //     >
    //       Enviar
    //     </Button>
    //   }
    // </Form>

